import { useState } from 'react';

/** Returns a value kept in browser storage under one key, and its setter. */
export function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw === null ? initialValue : (JSON.parse(raw) as T);
    } catch {
      return initialValue;
    }
  });

  const set = (next: T | ((previous: T) => T)) => {
    setValue((previous) => {
      const resolved = next instanceof Function ? next(previous) : next;
      try {
        window.localStorage.setItem(key, JSON.stringify(resolved));
      } catch {
        // Private mode or a full quota — keep the in-memory value.
      }
      return resolved;
    });
  };

  return [value, set] as const;
}
